<template>
  <v-app id="app" :class="{'is-mobile': $vuetify.breakpoint.mobile}">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.BH.loadTheme();
  },
};
</script>
